export const COLORS = {
  backgroundColorDarkTheme: 'var(--app-bg)',
  tableBackgroundColor: 'var(--app-surface-1)',
  tableHeaderColor: 'var(--app-surface-header)',
  borderColorDarkTheme: 'var(--app-table-border)',
  fontColorDarkTheme: 'var(--app-text)',
};

export const STAGE_CONFIG: Record<string, { label: string; color: 'success' | 'warning' | 'error' | 'info' }> = {
  Queued: { label: 'Na fila', color: 'info' },
  Downloading: { label: 'Baixando', color: 'warning' },
  ConvertingCodec: { label: 'Convertendo codec', color: 'warning' },
  AddingOverlays: { label: 'Adicionando overlays', color: 'warning' },
  GeneratingThumbnail: { label: 'Gerando thumbnail', color: 'warning' },
  Uploading: { label: 'Enviando', color: 'warning' },
  CreatingRecord: { label: 'Criando registro', color: 'warning' },
  Completed: { label: 'Concluído', color: 'success' },
  Failed: { label: 'Falhou', color: 'error' },
};

export const ORIGIN_CONFIG: Record<
  'New' | 'Automatic' | 'Manual',
  { label: string; color: 'success' | 'warning' | 'error' | 'info' | 'default' }
> = {
  New: { label: 'Novo', color: 'default' },
  Automatic: { label: 'Retry automático', color: 'info' },
  Manual: { label: 'Retry manual', color: 'warning' },
};

// Ordem real das etapas no backend (sports-api) — usado pra saber quais já foram concluídas.
export const STAGE_ORDER = [
  'Queued',
  'Downloading',
  'ConvertingCodec',
  'AddingOverlays',
  'GeneratingThumbnail',
  'Uploading',
  'CreatingRecord',
  'Completed',
] as const;
